<% if (array.length > 0) for (var i = 0; i < array.length; i++) { %>
	<%- include('/ui/form', {
		params: [ `${name_prefix}_${i}`, array[i] ],
		fields
	}) %>
<% } else { %>
	<div class="p-2 text-center text-dim"><%- placeholder %></div>
<% } %>
